import { Box, Card, Grid } from "@mui/material";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiAddButton from "src/components/core-components/mui/buttons/ByzMuiAddButton";
import ByzDaySelectButton from "src/components/core-components/mui/ByzDaySelect";
import ByzMuiPrintButton from "src/components/core-components/mui/buttons/ByzMuiPrintButton";
import { formatLongDate } from "src/utils/date";
import { useTranslate } from "src/locales";

interface PatientCareHeaderProps {
  date: string;
  onAddClick: () => void;
  onDateChange: (day: 'previous' | 'next' | 'today') => void;
}

const PatientCareHeader = ({ date, onAddClick, onDateChange }: PatientCareHeaderProps) => {
  const { t } = useTranslate();

  return (
    <Card sx={{ marginBottom: "5px" }}>
      <Box
        sx={{
          m: 1,
          ms: 0,
          pb: 1,
          borderBottom: "1px solid #E0E0E0",
          display: "flex",
          flexDirection: "row",
        }}
      >
        <ByzMuiTypography fontWeight="bold" mr={5}>
          {t("patient-care.add-maintenance")}
        </ByzMuiTypography>

        <ByzMuiTypography fontWeight="275" fontSize={"15px"}>
          {t("date")} : {formatLongDate(date)}
        </ByzMuiTypography>
      </Box>

      <Grid
        container
        spacing={3}
        sx={{ p: 2, pt: 0, pe: 0 }}
        alignItems="stretch"
        justifyContent={{ xs: "flex-start", md: "space-between" }}
      >
        <Grid item xs={12} md="auto" display="flex" alignItems="center" gap={2}>
          <ByzMuiAddButton
            variant="contained"
            color="primary"
            link=""
            onClick={onAddClick}
            popup={true}
          />

          <Box display="flex" alignItems="center">
            <ByzDaySelectButton
              previousText={t("patient-care.previous-day")}
              todayText={t("patient-care.today")}
              nextText={t("patient-care.next-day")}
              onChange={onDateChange}
            />
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          md="auto"
          display="flex"
          alignItems="center"
          justifyContent={{ xs: "flex-start", md: "flex-end" }}
          flexGrow={{ xs: 1, md: 0 }}
        >
          <Box display="flex" gap={1}>
            <ByzMuiPrintButton type={1} />
            <ByzMuiPrintButton type={2} />
            <ByzMuiPrintButton type={3} />
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
};

export default PatientCareHeader;
